// extracted by mini-css-extract-plugin
export var boxItem_icon = "BoxList-module--boxItem_icon--7be8f";
export var boxList_item = "BoxList-module--boxList_item--e251b";
export var boxList_wrap = "BoxList-module--boxList_wrap--5e674";